module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22.9 20\">\n    <path class=\"a\" d=\"M13.4,2A10,10,0,0,0,3.9,9L2.3,6.3.6,7.3l3.5,6.1,6.1-3.5-1-1.7-3.5,2A8,8,0,1,1,13.4,20v2a10,10,0,0,0,0-20Z\"\n        transform=\"translate(-0.6 -2)\" />\n</svg>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/reset.svg
// module id = 815
// module chunks = 1